/**
 * フェス風モーダルの上下に置く紺と金の装飾帯
 * 強制表示告知・投票・投票結果モーダルで共通利用します
 */

import React from 'react';
import { View } from '../../../shared/components/WebPrimitives';

/** 装飾帯に並べる金色のひし形 */
const ORNAMENT_INDEXES = [0, 1, 2, 3, 4, 5, 6];

/**
 * 上下の紺と金の装飾帯
 * @returns {JSX.Element} 装飾帯
 */
const FestivalOrnamentStrip = () => (
  <View
    className="h-[12px] shrink-0 flex-row items-center justify-center gap-[7px] border-y-2 border-[#D4AD43] bg-[#1A2D4D]"
    testID="festival-ornament-strip"
  >
    {ORNAMENT_INDEXES.map((index) => (
      <View key={index} className="h-[5px] w-[5px] shrink-0 rotate-45 bg-[#F5CF67]" />
    ))}
  </View>
);

export default FestivalOrnamentStrip;
